import React from 'react';
import { Box, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

const Wrapper = styled(Box)`
  &:hover {
    color: ${({ theme }) => theme.colors.textAccent};
    background-color: ${({ theme }) => theme.colors.accentContainer};
  }
`;

const AddNewProcessingRuleTitle = () => (
  <Wrapper
    fill
    align="start"
    pad={{ bottom: 'spacing2', top: 'spacing2', horizontal: 'spacing4' }}
    round="dropdownItemRound"
  >
    <Text size="medium" weight="normal" color="textAccent">
      Create a New Processing Rule
    </Text>
  </Wrapper>
);

export default AddNewProcessingRuleTitle;
